<template>
	<select @change='change' v-model="selected" class='table-control form-control my-control' :disabled='disabled'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const DOCS = 'get_official_docs.php'
	const WARRANT_INFO = 'get_warrant_info.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'official_docs',
		data: function () { 
			return {
				selected: '0',
				options: []
			}
		},
		props: {
			disabled: false
		},
		methods: {
			change () {
				EventBus.$emit(`official_docs`, this.selected)
			}
		},
		created () {
			fetch(DB + WARRANT_INFO + '?id=' + this.$route.params.id, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				return res[0].f_71
			})
			.then((id) => {
				fetch(DB + DOCS, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.options = data
						if(id === null)
							this.selected = data[0].id
						else
							this.selected = id
					}
					else {
						this.options = []
					}
					this.change()
				})
				.catch(err => console.log(err))
			})
			.catch(err => console.log(err))
		},
	}
</script>


// WEBPACK FOOTER //
// officialDocs.vue?e7cc0f18